import React, { useContext } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  makeStyles
} from '@material-ui/core';
import FormContext from 'components/Form/FormContext';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    backgroundColor: '#fafafa !important'
  },
  selectMenu: {
    backgroundColor: '#fafafa'
  }
}));

const ImageSelect = ({ onSelectImage, dataField, dishLabel }) => {
  const classes = useStyles();
  const { getFieldValue } = useContext(FormContext);

  // Extracting value and checking for null/undefined (Node 13 compatible)
  const selectedValue = getFieldValue(dataField) || {};
  const selectedLogoId = selectedValue.logoId ? selectedValue.logoId : '';

  const handleChange = event => {
    const selectedOption = dishLabel.find(function(option) {
      return option.logoId === event.target.value;
    });
    onSelectImage(selectedOption);
  };

  return (
    <FormControl variant="filled" fullWidth>
      <InputLabel>Select a dish label</InputLabel>
      <Select
        value={selectedLogoId}
        classes={{ root: classes.selectRoot }}
        MenuProps={{
          classes: { paper: classes.selectMenu }
        }}
        onChange={handleChange}
        label="Select a dish label"
      >
        <MenuItem key="select-item/none">
          <em>
            <FormattedMessage id="ppsi.utensilSelectEmpty" />
          </em>
        </MenuItem>
        {dishLabel && dishLabel.length > 0 ? (
          dishLabel.map(function(option) {
            return (
              <MenuItem key={option.logoId} value={option.logoId}>
                <img
                  src={option.dishLogo.thumbnailUrl}
                  alt="Logo"
                  style={{ width: 24, height: 24, marginRight: 10 }}
                />
                {option.label}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem disabled>
            No Label available.
            <br />
            Upload one in Market Settings.
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default ImageSelect;
